import React, { useState } from 'react';
import './Login.css';
import './LoginImage.css';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import 'react-jquery-plugin';
import AppStore from '../../../assets/images/IOS.png';
import PlayStore from '../../../assets/images/GooglePlay.png';
import { loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import ServerStatus from '../../../utils/ServerStatus';
import { GetBackendUrlForGlobalFunctions } from './../../../App';
import { store } from '../../../store';
import {useSelector} from "react-redux";

const Login = ({
  fetchTheCurrentUser,
}: {
  fetchTheCurrentUser: (token: string) => void;
}) => {
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [eyeShow, setEyeShow] = useState(false);
  const [defaultValue, setDefaultValue] = useState('English');
  const passwordHandler = (event: any) => {
    setPassword(event.target.value);
  };

  const usernameHandler = (event: any) => {
    setUsername(event.target.value);
  };

  const toggleEye = () => {
    setEyeShow(!eyeShow);
  };

  const contractEnd = (args: any) => {
    args.preventDefault();
    loadingShow(true);
    checkTheUser(username, password);
  };

  const handleChange = (event: any) => {
    setDefaultValue(event.target.value);
  };

  const checkTheUser = (username: string, password: string) => {
    loadingShow(true, 'Checking...');
    fetch(GetBackendUrlForGlobalFunctions() + 'auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.access_token) {
          fetchTheCurrentUser(res.access_token);
        } else {
          Message.error('Invalid username or password');
        }
        loadingShow(false);
      })
      .catch((err) => {
        console.log(err);
        Message.error('Something went wrong');
        loadingShow(false);
      });
  };

  const ERP_TYPE = useSelector((state: any) => state.search.erpType);
  return (
    <div className='uw-login-page' id='uw-login-page'>
      <div id='loading' style={{ visibility: 'hidden' }}>
        <div className='d-flex justify-content-center'>
          <div className='spinner-border' role='status'></div>
        </div>
      </div>
      <div id='appMountPoint'>
        <div className='login-wrapper hybrid-login-wrapper'>
          <div className='login-wrapper-background'>
            <div className='cat2'></div>
          </div>
          <div className='cbpHeader login-header signupBasicHeader'>
            <div
              className='logo signupBasicHeader'
              style={{
                padding: '0px',
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start"
              }}
            >
              <img className='image-icon' src='uwnew.png' height={91} />
            </div>
            <div
                className='logo signupBasicHeader'
                style={{
                  padding: '0px',
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start"
                }}
            >
              {ERP_TYPE === "JD Edwards" && <img className='image-icon' src='oracle-logo.png' height={110} />}
            </div>
          </div>
          <div className='login-body' id='signin'>
            <div className='login-content login-form hybrid-login-form hybrid-login-form-signup'>
              <div className='hybrid-login-form-main'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '50%',
                    marginBottom: '20px',
                  }}
                >
                  <h1 style={{ margin: 0 }}>Sign In</h1>
                  <ServerStatus />
                </div>
                <form id='uw-login-form' onSubmit={contractEnd}>
                  <div className='login-form'>
                    <div className='cbpInput cbpEmailPhoneInput login-input login-input-email'>
                      <div className='cbpInputPlacement'>
                        <div className='cbpEmailPhoneControls'>
                          <div className='input_id'>
                            <input
                              id='uw-email'
                              type='email'
                              onChange={usernameHandler}
                              name='userLoginId'
                              className='cbpTextfield'
                              autoComplete='off'
                              placeholder='Email or phone number'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='cbpInput cbpEmailPhoneInput login-input login-input-email'>
                      <div className='cbpInputPlacement'>
                        <div className='cbpEmailPhoneControls'>
                          <div className='input_id'>
                            <input
                              id='uw-password'
                              type={eyeShow ? 'text' : 'password'}
                              onChange={passwordHandler}
                              name='password'
                              className='cbpTextfield'
                              autoComplete='off'
                              placeholder='Password'
                            />
                            <div className='eye'>
                              {eyeShow ? (
                                <AiFillEyeInvisible onClick={toggleEye} />
                              ) : (
                                <AiFillEye onClick={toggleEye} />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        id='contract'
                        className='btn login-button btn-submit btn-small'
                        type='submit'
                      >
                        Sign In
                      </button>
                    </div>
                    <div className='hybrid-login-form-help'>
                      <div className='ui-binary-input '>
                        <input
                          type='checkbox'
                          className='login-remember-me'
                          name='RememberMe'
                        />
                        <label className='rememberLabel' htmlFor='contract'>
                          Remember me
                        </label>
                      </div>
                      <a className='linkHelp' href='#'>
                        Need help?
                      </a>
                    </div>
                  </div>
                  <div className='hybrid-login-form-other'>
                    <div className='login-signup-now'>
                      <label className='cbp' htmlFor='contract'>
                        Don't have an account?{' '}
                      </label>
                      <a id='signinClick' href='#' className='sgnup'>
                        {' '}
                        Sign up
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* <div className='login-body' id='signup'>
            <div className='login-content login-form hybrid-login-form hybrid-login-form-signup'>
              <div className='hybrid-login-form-main'>
                <h1>Sign up</h1>
                <div className='login-form'>
                  <div className='cbpInput cbpEmailPhoneInput login-input login-input-email'>
                    <div className='cbpInputPlacement'>
                      <div className='cbpEmailPhoneControls'>
                        <div className='input_id'>
                          <input
                            type='text'
                            onChange={usernameHandler}
                            name='userLoginId'
                            className='cbpTextfield'
                            autoComplete='email'
                            placeholder='Email or phone number'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='cbpInput cbpEmailPhoneInput login-input login-input-email'>
                    <div className='cbpInputPlacement'>
                      <div className='cbpEmailPhoneControls'>
                        <div className='input_id'>
                          <input
                            type={eyeShow ? 'text' : 'password'}
                            onChange={passwordHandler}
                            name='password'
                            className='cbpTextfield'
                            autoComplete='password'
                            placeholder='Password'
                          />
                          <div className='eye'>
                            {eyeShow ? (
                              <AiFillEyeInvisible onClick={toggleEye} />
                            ) : (
                              <AiFillEye onClick={toggleEye} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='cbpInput cbpEmailPhoneInput login-input login-input-email'>
                    <div className='cbpInputPlacement'>
                      <div className='cbpEmailPhoneControls'>
                        <div className='input_id'>
                          <input
                            type={eyeShow ? 'text' : 'password'}
                            onChange={passwordHandler}
                            name='password'
                            className='cbpTextfield'
                            autoComplete='password'
                            placeholder=' Confirm password'
                          />
                          <div className='eye'>
                            {eyeShow ? (
                              <AiFillEyeInvisible onClick={toggleEye} />
                            ) : (
                              <AiFillEye onClick={toggleEye} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button className='btn login-button btn-submit btn-small'>
                    Sign Up
                  </button>
                  <div className='split'>OR</div>
                </div>
                <div className='hybrid-login-form-other'>
                  <div className='login-signup-now'>
                    <label className='cbp' >
                      Already have an account?
                    </label>
                    <a id='signupClick' href='#' className='sgnup'>
                      Log In
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className='site-footer-wrapper centered'>
            <div className='site-footer'>
              <div
                style={{
                  alignItems: 'flex-start',
                  display: 'flex',
                  alignContent: 'flex-start',
                }}
              >
                <img
                  src={AppStore}
                  alt=''
                  style={{ height: '35px', marginRight: '30px' }}
                />
                <img src={PlayStore} alt='' style={{ height: '35px' }} />
              </div>
              <div className='lang-selection-container'>
                <select
                  defaultValue={defaultValue}
                  onChange={handleChange}
                  name=''
                  id='uw-lang-select'
                  className='ui-select'
                >
                  <option
                    id='tr-lang'
                    value='TR'
                    data-language='tr'
                    data-country='TR'
                  >
                    Türkçe
                  </option>
                  <option
                    lang='en'
                    value='English'
                    data-language='en'
                    data-country='TR'
                  >
                    English
                  </option>
                </select>
              </div>
              <ul className='footer-links'>
                <li className=' '>
                  <a className='footer-link' href='#'>
                    FAQ
                  </a>
                </li>
                <li className='footer-link-item'>
                  <a className='footer-link' href='#'>
                    Help Centre
                  </a>
                </li>
                <li className='footer-link-item'>
                  <a className='footer-link' href='#'>
                    Term of Use
                  </a>
                </li>
                <li className='footer-link-item'>
                  <a className='footer-link' href='#'>
                    Privacy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
